import { deleteDocument } from "app/api/documentsApi";
import { VerificationDocumentType } from "app/types/documentType";
import { AxiosError } from "axios"; // Import AxiosError
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import "./DocumentListView.scss";

type Props = {
  documentList: VerificationDocumentType[];
  updateDocumentList: () => void;
};

const DocumentListView = ({ documentList, updateDocumentList }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const handleOnClickRemove = async ev => {
    try {
      await deleteDocument(ev.currentTarget.dataset.id);
      setErrorMessage("");
      updateDocumentList();
    } catch (error) {
      console.error("Document deletion failed:", error);

      if (error instanceof AxiosError && error.response) {
        const errorData = error.response.data;
        setErrorMessage(errorData.errors[0].detail);
      } else {
        setErrorMessage("An unexpected error occurred.");
      }
    }
  };

  const renderDocumentList = () => {
    if (documentList.length > 0) {
      return documentList.map((doc, index) => (
        <div key={doc.id} className="documents-list__item">
          <span>{doc.documentName}</span>
          <button
            className="button documents-list__remove-button"
            onClick={handleOnClickRemove}
            data-id={doc.id}
          >
            <FormattedMessage tagName="span" id="remove" />
          </button>
        </div>
      ));
    }

    return null;
  };

  return (
    <div className="documents-list">
      {renderDocumentList()}
      <span className="documents-list__error">{errorMessage}</span>
    </div>
  );
};

export default DocumentListView;
